import React from "react";
import "./index.scss";

const ErrorMessage = ({ className = '' }) => {
	return (
		<>
			<div className={`error-msg-blc text-center d-flex align-items-center justify-content-center h-100 ${className}`}>
				<div className="inner">
					<p>Unable to generate analyzer documents. 
					<span> Please retry or contact support if the issue continues.</span>
					</p>
					<div className="pic">
						<img className="img-fluid" src={require('../../../assets/img/doc-pic.png')} />
					</div>
				</div>
			</div>
		</>
	);
}

export default ErrorMessage;